import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import { RouterTabRoutes } from 'vue-router-tab';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import Common from '@/api/common';
NProgress.configure({showSpinner: false});

Vue.use(Router);
const originalPush = Router.prototype.push;
// TODO:
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(() => {});
};

// 重写了VueRouter的go和back方法，在router返回时关闭当前页签
Router.prototype.go = Router.prototype.back = function go () {
  let items = Vue.prototype.$tabs?.items;
  let activeItemId = Vue.prototype.$tabs?.activeTabId;
  let activeItemIndex = items.findIndex((t) => t.id === activeItemId);
  if (activeItemIndex > 0) {
    Vue.prototype.$tabs.close({ id: activeItemId, to: items[activeItemIndex - 1].to });
  } else {
    if (items.length === 1) {
      Vue.prototype.$tabs.close({ id: activeItemId, to: store.getters.firstUrl });
    } else {
      Vue.prototype.$tabs.close();
    }
  }
};

// 重新replace方法，使之匹配vue-routeTab
const originReplace = Router.prototype.replace;
Router.prototype.replace = function replace () {
  let activeTabId = Vue.prototype.$tabs?.activeTabId;
  originReplace.apply(this, arguments).then(() => {
    activeTabId && Vue.prototype.$tabs.close({ id: activeTabId });
  });
};

const routes = [
  {
    path: '/login',
    name: 'LOGIN',
    component: () => import('@/views/LoginRegister.vue'),
  },
  // 资料分享活动 - 客户扫码页（无需登录）
  {
    path: '/activity/scan',
    name: 'ACTIVITY_SCAN',
    component: () => import('@/views/Marketing/activity/scan.vue'),
    meta: { title: '资料下载', public: true },
  },
  {
    path: '/',
    name: 'HOME',
    component: () => import('@/views/Layout/index.vue'),
    redirect: { name: 'WORKBENCH' },
    children: [
      ...RouterTabRoutes,
      {
        path: 'userInfo',
        name: 'USER_INFO',
        component: () => import('@/views/UserInfo.vue'),
        meta: {
          title: '账号安全',
        },
      },
      {
        path: 'userDrawer',
        name: 'USER_DRAWER',
        component: () => import('@/views/UserDrawer/index.vue'),
        meta: {
          title: '个人资料',
        },
      },
      {
        path: 'order/list',
        name: 'ORDER_INDEX',
        component: () => import('@/views/Order/index.vue'),
        meta: {
          title: '工单列表',
        },
      },
      {
        path: 'order/collaborativeTicketsList',
        name: 'ORDER_COLLABORATIVETICKETSLIST',
        component: () => import('@/views/Order/index.vue'),
        props: () => ({ isSynergy: true }),
        meta: {
          title: '协同工单列表',
        },
      },

      {
        path: 'workbench',
        name: 'WORKBENCH',
        component: () => import('@/views/Workbench/index.vue'),
        meta: {
          title: '服务大厅',
          module: 'homePage',
          closable: false,
        },
      },
      {
        path: 'company/list',
        name: 'COMPANYLISTS',
        component: () => import('@/views/Company/index.vue'),
        meta: {
          title: '全部企业',
          module: 'homePage',
        },
      },
      {
        path: 'workbench/identification',
        name: 'IDENTIFICATION',
        component: () => import('@/views/Workbench/identification.vue'),
        meta: {
          title: '企业认证',
          module: 'homePage',
        },
      },
      {
        path: 'workbench/messages',
        name: 'MESSAGES',
        component: () => import('@/views/Workbench/messages.vue'),
        meta: {
          title: '消息中心',
          module: 'homePage',
        },
      },
      {
        path: 'workbench/notices',
        name: 'NOTICES',
        component: () => import('@/views/Workbench/notices.vue'),
        meta: {
          title: '平台公告',
          module: 'homePage',
        },
      },
      {
        path: 'join/supplyDemand',
        name: 'JOIN_SUPPLY_DEMAND',
        component: () => import('@/views/Join/supplyDemand.vue'),
        meta: {
          title: '供需通介绍',
          module: 'homePage',
        },
      },
      {
        path: 'join/xiaozi',
        name: 'JOIN_XIAOZI',
        component: () => import('@/views/Join/xiaozi.vue'),
        meta: {
          title: '加盟服务',
          module: 'homePage',
        },
      },
      {
        path: 'join/yixiubao',
        name: 'JOIN_YIXIUBAO',
        component: () => import('@/views/Join/yixiubao.vue'),
        meta: {
          title: '医修保',
          module: 'homePage',
        },
      },
      {
        path: 'orderWall',
        name: 'ORDERWALL',
        component: () => import('@/views/OrderWall/index.vue'),
        meta: {
          title: '医修保首页',
        },
      },
      {
        path: 'orderWall/synergism',
        name: 'ORDERWALL_SYNERGISM',
        component: () => import('@/views/OrderWall/synergism.vue'),
        meta: {
          title: '全部待办',
          module: 'yxb',
        },
      },
      {
        path: 'order/add',
        name: 'ORDER_ADD',
        component: () => import('@/views/Order/edit.vue'),
        props: route => ({ ...route.query }),
        meta: {
          title: '新增工单',
        },
      },
      {
        path: 'order/edit',
        name: 'ORDER_EDIT',
        component: () => import('@/views/Order/edit.vue'),
        props: route => ({ ...route.query }),
        meta: {
          title: '编辑工单',
        },
      },
      {
        path: 'external/order/edit',
        name: 'EXTERNAL_ORDER_EDIT',
        component: () => import('@/views/Order/edit.vue'),
        props: route => ({ ...route.query, isSynergy: true }),
        meta: {
          title: '协同工单编辑',
          key: 'fullPath',
          module: 'yxb',
        },
      },
      {
        path: '/import/:type',
        name: 'ORDER_IMPORT',
        component: () => import('@/views/Order/import.vue'),
        props: route => ({ ...route.params }),
        meta: {
          title: '批量新增',
          key: 'path',
          module: 'yxb',
        },
      },
      {
        path: 'customer/list',
        name: 'CUSTOMER_INDEX',
        component: () => import('@/views/Customer/index.vue'),
        meta: {
          title: '客户档案',
        },
      },
      {
        path: 'customer/add',
        name: 'CUSTOMER_ADD',
        component: () => import('@/views/Customer/detail.vue'),
        meta: {
          title: '新增客户',
        },
      },
      {
        path: 'customer/detail',
        name: 'CUSTOMER_DETAIL',
        component: () => import('@/views/Customer/detail.vue'),
        meta: {
          title: '客户档案详情',
        },
      },
      {
        path: 'customer/edit',
        name: 'CUSTOMER_EDIT',
        component: () => import('@/views/Customer/detail.vue'),
        meta: {
          title: '客户档案编辑',
        },
      },
      {
        path: 'contact/list',
        name: 'CONTACT_INDEX',
        component: () => import('@/views/Contact/index.vue'),
        meta: {
          title: '客户联系人',
        },
      },
      {
        path: 'contact/add',
        name: 'CONTACT_ADD',
        component: () => import('@/views/Contact/detail.vue'),
        meta: {
          title: '新增联系人',
        },
      },
      {
        path: 'contact/detail',
        name: 'CONTACT_DETAIL',
        component: () => import('@/views/Contact/detail.vue'),
        meta: {
          title: '客户联系人详情',
        },
      },
      {
        path: 'accounts/list',
        name: 'ACCOUNTS_INDEX',
        component: () => import('@/views/Accounts/index.vue'),
        meta: {
          title: '客户端账套',
        },
      },
      {
        path: '/systemSettings/userInfo',
        name: 'UserInfo',
        component: () => import('@/views/SystemSettings/userInfo/userInfo.vue'),
        meta: {
          title: '客户端设置',
        },
      },
      {
        path: '/systemSetting/account/list',
        name: 'Account',
        component: () => import('@/views/SystemSettings/account/index.vue'),
        meta: {
          title: '云市场订单',
        },
      },
      {
        path: '/systemSetting/department/list',
        name: 'Department',
        component: () => import('@/views/SystemSettings/department/index.vue'),
        meta: {
          title: '部门管理',
        },
      },
      {
        path: '/systemSetting/employee/list',
        name: 'Employee',
        component: () => import('@/views/SystemSettings/employee/index.vue'),
        meta: {
          title: '成员管理',
        },
      },
      {
        path: '/systemSetting/employee/detail',
        name: 'EmployeeDetail',
        component: () => import('@/views/SystemSettings/employee/detail.vue'),
        meta: {
          title: '员工详情',
        },
        props: route => ({
          id: route.query.id,
        }),
      },
      {
        path: '/systemSetting/corporate/certification',
        name: 'Company',
        component: () => import('@/views/SystemSettings/company/index.vue'),
        meta: {
          title: '企业认证',
        },
      },
      {
        path: '/systemSetting/company/profile',
        name: 'CompanyProfile',
        component: () => import('@/views/SystemSettings/company/profile.vue'),
        meta: {
          title: '企业档案',
        },
      },
      {
        path: '/systemSetting/company/detail',
        name: 'CompanyDetail',
        component: () => import('@/views/SystemSettings/company/detail.vue'),
        meta: {
          title: '加盟服务-详情',
        },
      },
      {
        path: '/systemSetting/corporate/certification/edit',
        name: 'CorporateCertification',
        component: () => import('@/views/SystemSettings/company/corporateCertification.vue'),
        meta: {
          title: '加盟服务-编辑',
        },
      },
      {
        path: '/systemSetting/portal/home',
        name: 'PortalHome',
        component: () => import('@/views/SystemSettings/company/PortalHome.vue'),
        meta: {
          title: '云产品中心',
        },
      },
      {
        path: '/systemSetting/employee/edit',
        name: 'EmployeeEdit',
        component: () => import('@/views/SystemSettings/employee/edit.vue'),
        meta: {
          title: '编辑员工',
        },
        props: route => ({
          id: route.query.id,
        }),
      },
      {
        path: '/systemSetting/role/list',
        name: 'Role',
        component: () => import('@/views/SystemSettings/role/index.vue'),
        meta: {
          title: '角色权限',
        },
      },
      {
        path: '/system/sparePartWarehouseSet',
        name: 'system_sparePartWarehouseSet',
        component: () => import('@/views/SystemSettings/stock'),
        meta: {
          title: '备件仓储设置',
        },
      },
      {
        path: '/systemSetting/attributeDict',
        name: 'AttributeDict',
        component: () => import('@/views/SystemSettings/AttributeDict/index.vue'),
        meta: {
          title: '属性字典',
        },
      },
      {
        path: '/feedback',
        name: 'FeedbackLists',
        component: () => import('@/views/Feedback/feedbackLists.vue'),
        meta: {
          title: '意见反馈',
          module: 'homePage',
        },
      },
      {
        path: '/feedback/add',
        name: 'AddFeedbackLists',
        component: () => import('@/views/Feedback/feedbackInfo.vue'),
        meta: {
          title: '新增意见反馈',
          module: 'homePage',
        },
      },
      {
        path: '/feedback/edit',
        name: 'EditFeedbackLists',
        component: () => import('@/views/Feedback/feedbackInfo.vue'),
        meta: {
          title: '编辑意见反馈',
          module: 'homePage',
        },
      },
      {
        path: '/feedback/view',
        name: 'ViewFeedbackLists',
        component: () => import('@/views/Feedback/feedbackInfo.vue'),
        meta: {
          title: '查看意见反馈',
          module: 'homePage',
        },
      },
      {
        path: '/sparePart/list',
        name: 'SPAREPART_LIST',
        component: () => import('@/views/StockIn/list'),
        meta: {
          title: '备件列表',
        },
      },
      {
        path: '/sparePart/sparePartType',
        name: 'SPAREPART_TYPE',
        component: () => import('@/views/StockIn/sparePartType'),
        meta: {
          title: '备件类型',
          module: 'yxb',
        },
      },
      {
        path: '/sparePart/list/detail',
        name: 'SPAREPART_DETAIL',
        component: () => import('@/views/StockIn/list/detail'),
        meta: {
          title: '备件详情',
          module: 'yxb',
        },
      },
      {
        path: '/sparePart/stock',
        name: 'SPAREPART_STOCK',
        component: () => import('@/views/StockIn/inventory'),
        meta: {
          title: '备件库存',
        },
      },
      {
        path: '/sparePart/stockInAndOutRecord',
        name: 'SPAREPART_STOCKINANDOUTRECORD',
        component: () => import('@/views/StockIn/record'),
        meta: {
          title: '出入库记录',
        },
      },
      {
        path: '/sparePart/handleStockInAndOut',
        name: 'SPAREPART_HANDLESTOCKINANDOUT',
        component: () => import('@/views/StockIn/deal'),
        meta: {
          title: '办理出入库',
        },
      },
      {
        path: 'sparePart/personalWarehouse',
        name: 'SPAREPART_PERSONALWAREHOUSE',
        component: () => import('@/views/StockIn/personal'),
        meta: {
          title: '个人备件库',
        },
      },
      {
        path: 'sparePart/stock/manager',
        name: 'SPAREPART_STOCK_MANAGER',
        component: () => import('@/views/StockIn/inventory/stockManager'),
        meta: {
          title: '管理仓库',
        },
      },
      {
        path: 'sparePart/stock/type/manager',
        name: 'SPAREPART_STOCK_TYPE_MANAGER',
        component: () => import('@/views/StockIn/inventory/stockType'),
        meta: {
          title: '管理仓库类型',
        },
      },
      {
        path: 'sparePart/handleStockInAndOut/detail',
        name: 'sparePart_handleStockInAndOut_detail',
        component: () => import('@/views/StockIn/deal/detail'),
        props: route => ({ id: route.query.id }),
        meta: {
          title: '办理出入库详情',
        },
      },
      {
        path: 'operation/report',
        name: 'OPERATION_REPORT',
        component: () => import('@/views/Operation/report/index'),
        meta: {
          title: '统计报表',
        },
      },
      {
        path: 'operation/report/detail',
        name: 'OPERATION_REPORT_DETAIL',
        component: () => import('@/views/Operation/report/detail'),
        meta: {
          title: '统计报表详情',
        },
        props: route => ({ ...route.query }),
      },
      {
        path: 'form/config',
        name: 'FORM_INDEX',
        component: () => import('@/views/Form/index'),
        meta: {
          title: '医搭',
        },
      },
      {
        path: 'form/setting',
        name: 'FORM_SETTING',
        component: () => import('@/views/Form/setting/form'),
        props: route => ({ ...route.query }),
        meta: {
          title: '自定义表单',
        },
      },
      {
        path: 'form/print/template',
        name: 'FORM_PRINT_TEMPLATE',
        component: () => import('@/views/Form/printTemplate/list'),
        props: route => ({ ...route.query }),
        meta: {
          title: '打印配置',
          module: 'yxb',
        },
      },
      {
        path: 'form/print/template/:action',
        name: 'FORM_PRINT_TEMPLATE_DETAIL',
        component: () => import('@/views/Form/printTemplate/detail'),
        props: route => ({ ...route.query }),
        meta: {
          title: '打印模板设置',
          module: 'yxb',
        },
      },
      {
        path: 'form/setting/component',
        name: 'FORM_SETTING_COMPONENT',
        component: () => import('@/views/Form/setting/component'),
        props: route => ({ ...route.query }),
        meta: {
          title: '自定义业务组件',
          module: 'yxb',
        },
      },
      {
        path: 'customForm/list/:configCode',
        name: 'CUSTOMFORM_LIST',
        component: () => import('@/components/commonForm'),
        props: route => ({ ...route.params }),
        meta: {
          title: '自定义列表',
          key: 'path',
        },
      },
      {
        path: 'customForm/add/:configCode',
        name: 'CUSTOMFORM_add',
        component: () => import('@/components/commonForm/edit.vue'),
        props: route => ({ ...route.params, ...route.query }),
        meta: {
          title: '自定义列表新增',
          key: 'path',
        },
      },
      {
        path: 'customForm/edit/:configCode',
        name: 'CUSTOMFORM_edit',
        component: () => import('@/components/commonForm/edit.vue'),
        props: route => ({ ...route.params, ...route.query }),
        meta: {
          title: '自定义列表编辑',
          key: 'path',
        },
      },
      {
        path: 'customForm/detail/:configCode',
        name: 'CUSTOMFORM_detail',
        component: () => import('@/components/commonForm/edit.vue'),
        props: route => ({ ...route.params, ...route.query }),
        meta: {
          title: '自定义列表详情',
          key: 'path',
        },
      },
      {
        path: 'salesmanagement/salescontracts/list',
        name: 'SALESMANAGEMENT_SALESCONTRACTS_LIST',
        component: () => import('@/views/SalesManagement/saleContracts/list.vue'),
        meta: {
          title: '销售合同',
        },
      },
      {
        path: 'salesmanagement/salescontracts/new',
        name: 'SALESMANAGEMENT_SALESCONTRACTS_NEW',
        component: () => import('@/views/SalesManagement/saleContracts/newSaleContract.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '新增销售合同',
        },
      },
      {
        path: 'salesmanagement/salescontracts/detail',
        name: 'SALESMANAGEMENT_SALESCONTRACTS_DETAIL',
        component: () => import('@/views/SalesManagement/saleContracts/detail.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '销售合同详情',
        },
      },
      {
        path: 'salesmanagement/salescontracts/purchDetail',
        name: 'SALESMANAGEMENT_PURCHCONTRACTS_DETAIL',
        component: () => import('@/views/SalesManagement/saleContracts/purchDetail.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '采购合同详情',
          module: 'yxb',
        },
      },
      {
        path: 'salesmanagement/billingOrder/list',
        name: 'SALESMANAGEMENT_BILLINGORDER_LIST',
        component: () => import('@/views/SalesManagement/billingOrder/list.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '销售订单',
        },
      },
      {
        path: 'salesmanagement/billingOrder/new',
        name: 'SALESMANAGEMENT_BILLINGORDER_NEW',
        component: () => import('@/views/SalesManagement/billingOrder/newSaleOrder.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '销售开单',
        },
      },
      {
        path: 'salesmanagement/billingOrder/detail',
        name: 'SALESMANAGEMENT_BILLINGORDER_SALE_DETAIL',
        component: () => import('@/views/SalesManagement/billingOrder/saleOrderDetail.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '订单详情',
        },
      },
      {
        path: 'salesmanagement/billingOrder/purchDetail',
        name: 'SALESMANAGEMENT_BILLINGORDER_PURCH_DETAIL',
        component: () => import('@/views/SalesManagement/billingOrder/purchOrderDetail.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '订单详情',
          module: 'yxb',
        },
      },
      {
        path: 'gongxutong',
        name: 'GONGXUTONG',
        component: () => import('@/views/Cooperation/subscription/list.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '协同订阅',
          module: 'gongxutong',
        },
      },
      {
        path: 'cooperation/enterprise/list',
        name: 'COOPRERATION_ENTERPRISE_LIST',
        component: () => import('@/views/Cooperation/enterprise/list.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '协同企业',
          module: 'gongxutong',
        },
      },
      {
        path: 'goods/connect',
        name: 'GOODSCONNECT',
        component: () => import('@/views/GoodsConnect/index.vue'),
        meta: {
          title: '商品对接',
          module: 'gongxutong',
        },
      },
      {
        path: 'VIS/product',
        name: 'Product',
        component: () => import('@/views/product/index.vue'),
        meta: {
          title: 'VIS商品',
          module: 'gongxutong',
        },
      },
      {
        path: 'inquiryForm/customerInquiryForm/list',
        name: 'CUSTOMER_INQUIRY_FORM',
        component: () => import('@/views/Inquiryform/customerInquiryForm/list.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '客户询价单',
          module: 'gongxutong',
        },
      },
      {
        path: 'inquiryForm/customerInquiryForm/handle',
        name: 'CUSTOMER_INQUIRY_HANDLE',
        component: () => import('@/views/Inquiryform/customerInquiryForm/handle.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '询价管理',
          module: 'gongxutong',
        },
      },
      {
        path: 'inquiryForm/recommendBusinessOpportunities/list',
        name: 'RECOMMEND_BUSINESS_OPPORTUNITIES',
        component: () => import('@/views/Inquiryform/recommendBusinessOpportunities/list.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '推荐商机',
          module: 'gongxutong',
        },
      },
      {
        path: 'salesManagement/pickUpOrders',
        name: 'PickUpOrders',
        component: () => import('@/views/pickUpOrders/index.vue'),
        meta: {
          title: '销售订单',
          module: 'gongxutong',
        },
      },
      {
        path: 'salesManagement/orderShip',
        name: 'OrderShip',
        component: () => import('@/views/OrderShip/index.vue'),
        meta: {
          title: '订单发货',
          module: 'gongxutong',
        },
      },
      {
        path: 'salesManagement/orderShip/fill',
        name: 'OrderShipFill',
        component: () => import('@/views/OrderShip/fill.vue'),
        meta: {
          title: '批量线下填单',
          module: 'gongxutong',
        },
      },
      {
        path: 'salesManagement/pickUpOrders/ship',
        name: 'PickUpOrdersShip',
        component: () => import('@/views/pickUpOrders/ship.vue'),
        meta: {
          title: '发货',
          module: 'gongxutong',
        },
        props: route => ({
          ...route.query,
        }),
      },
      {
        path: 'salesManagement/pickUpOrders/detail',
        name: 'PickUpOrdersDetail',
        component: () => import('@/views/pickUpOrders/detail.vue'),
        meta: {
          title: '订单详情',
          module: 'gongxutong',
        },
        props: route => ({
          ...route.query,
        }),
      },
      {
        path: 'salesManagement/saleContract',
        name: 'SaleContract',
        component: () => import('@/views/saleContract/index.vue'),
        meta: {
          title: '销售合同',
          module: 'gongxutong',
        },
      },
      {
        path: 'salesManagement/saleContract/detail',
        name: 'SaleContractDetail',
        component: () => import('@/views/saleContract/detail.vue'),
        meta: {
          title: '销售合同详情',
          module: 'gongxutong',
        },
        props: route => ({
          id: route.query.id,
          type: route.query.type,
        }),
      },
      {
        path: 'salesManagement/saleContract/review',
        name: 'SaleContractReview',
        component: () => import('@/views/saleContract/detail.vue'),
        meta: {
          title: '销售合同审核',
          module: 'gongxutong',
        },
        props: route => ({
          id: route.query.id,
          type: route.query.type,
        }),
      },
      {
        path: 'afterSaleManagement/service',
        name: 'Service',
        component: () => import('@/views/service/afterSales/index.vue'),
        meta: {
          title: '售后订单',
          module: 'gongxutong',
        },
      },
      {
        path: 'afterSaleManagement/service/detail',
        name: 'ServiceDetail',
        component: () => import('@/views/service/afterSales/detail.vue'),
        meta: {
          title: '售后详情',
          module: 'gongxutong',
        },
        props: route => ({
          id: route.query.id,
          outRefundId: route.query.outRefundId,
          type: route.query.type,
          returnType: route.query.returnType,
        }),
      },
      {
        path: 'afterSaleManagement/service/review',
        name: 'ServiceReview',
        component: () => import('@/views/service/afterSales/detail.vue'),
        meta: {
          title: '售后审核',
          module: 'gongxutong',
        },
        props: route => ({
          id: route.query.id,
          outRefundId: route.query.outRefundId,
          type: route.query.type,
          returnType: route.query.returnType,
        }),
      },
      {
        path: 'afterSaleManagement/service/return',
        name: 'ServiceReturn',
        component: () => import('@/views/service/receiveReturns/index.vue'),
        meta: {
          title: '售后退货',
          module: 'gongxutong',
        },
      },
      {
        path: 'afterSaleManagement/service/returnDetail',
        name: 'ServiceReturnDetail',
        component: () => import('@/views/service/receiveReturns/detail.vue'),
        meta: {
          title: '退货确认详情',
          module: 'gongxutong',
        },
        props: route => ({
          id: route.query.id,
        }),
      },
      {
        path: 'logistics/invoiceMgr',
        name: 'InvoiceMgr',
        component: () => import('@/views/invoiceMgr/index.vue'),
        meta: {
          title: '发货记录',
          module: 'gongxutong',
        },
      },
      {
        path: 'logistics/invoiceMgr/detail',
        name: 'InvoiceMgrDetail',
        component: () => import('@/views/invoiceMgr/detail.vue'),
        meta: {
          title: '发货记录详情',
          module: 'gongxutong',
        },
        props: route => ({
          ...route.query,
        }),
      },
      {
        path: 'logistics/sendForRepair/list',
        name: 'LOGISTICS_SEND_FOR_REPAIR',
        component: () => import('@/views/Logistics/sendForRepair/list.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '寄修单',
          module: 'gongxutong',
        },
      },
      {
        path: 'logistics/sendForRepair/detail',
        name: 'LOGISTICS_SEND_FOR_REPAIR_DETAIL',
        component: () => import('@/views/Logistics/sendForRepair/detail.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '寄修单详情',
          module: 'gongxutong',
        },
      },
      {
        path: 'logistics/backupEquipment/list',
        name: 'LOGISTICS_BACKUP_EQUIPMENT',
        component: () => import('@/views/Logistics/backupEquipment/list.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '备用机',
          module: 'gongxutong',
        },
      },
      {
        path: 'logistics/backupEquipment/detail',
        name: 'LOGISTICS_BACKUP_EQUIPMENT_DETAIL',
        component: () => import('@/views/Logistics/backupEquipment/detail.vue'),
        props: route => ({...route.query}),
        meta: {
          title: '备用机详情',
          module: 'gongxutong',
        },
      },
      {
        path: 'reconciliation/accountStatement/list',
        name: 'AccountStatement',
        component: () => import('@/views/salesReconciliation/accountStatement/index.vue'),
        meta: {
          title: '对账单',
          module: 'gongxutong',
        },
      },
      {
        path: 'reconciliation/accountStatement/detail',
        name: 'DetailAccountStatement',
        component: () => import('@/views/salesReconciliation/accountStatement/detail.vue'),
        meta: {
          title: '对账单详情',
          module: 'gongxutong',
        },
      },
      {
        path: 'reconciliation/deliveryRecord',
        name: 'DeliveryRecord',
        component: () => import('@/views/salesReconciliation/deliveryRecord.vue'),
        meta: {
          title: '出库记录',
          module: 'gongxutong',
        },
      },
      {
        path: 'reconciliation/returnRecord',
        name: 'ReturnRecord',
        component: () => import('@/views/salesReconciliation/returnRecord.vue'),
        meta: {
          title: '退货记录',
          module: 'gongxutong',
        },
      },
      {
        path: 'shop/goods',
        name: 'SHOP_GOODS',
        component: () => import('@/views/Shop/goods.vue'),
        meta: {
          title: '平台销售',
          module: 'gongxutong',
        },
      },
      {
        path: 'shop/subscribe',
        name: 'SHOP_SUBSCRIBE',
        component: () => import('@/views/Shop/subscribe.vue'),
        meta: {
          title: '订阅销售',
          module: 'gongxutong',
        },
      },
      {
        path: 'supplyDemand/setting',
        name: 'SUPPLY_DEMAND_SETTING',
        component: () => import('@/views/SupplyDemand/setting.vue'),
        meta: {
          title: '供需通设置',
          module: 'gongxutong',
        },
      },
      {
        path: 'goodsCategory',
        name: 'GOODS_CATEGORY',
        component: () => import('@/views/Category/index.vue'),
        props: () => ({
          name: '商品分类',
        }),
        meta: {
          title: '商品分类',
          module: 'gongxutong',
        },
      },
      {
        path: 'goods',
        name: 'GOODS',
        component: () => import('@/views/Goods/index.vue'),
        meta: {
          title: '商品管理',
          module: 'gongxutong',
        },
      },
      {
        path: 'e-signature/controlDesk',
        name: 'ControlDesk',
        component: () => import('@/views/E-Signature/controlDesk/index.vue'),
        meta: {
          title: '电子签控制台',
          module: 'gongxutong',
        },
      },
      {
        path: 'e-signature/account',
        name: 'EAccount',
        component: () => import('@/views/E-Signature/E-Account/index.vue'),
        meta: {
          title: '电子签账户',
          module: 'gongxutong',
        },
      },
      {
        path: 'e-signature/contractDispatch',
        name: 'ContractDispatch',
        component: () => import('@/views/E-Signature/contractDispatch/index.vue'),
        meta: {
          title: '合同文件发起',
          module: 'gongxutong',
        },
      },
      {
        path: 'e-signature/tencentUpload',
        name: 'TencentUpload',
        component: () => import('@/views/E-Signature/contractDispatch/tencentIFrame.vue'),
        meta: {
          title: '合同文件发起',
          module: 'gongxutong',
        },
      },
      // ===== 资料分享活动 =====
      {
        path: 'marketing/activity/list',
        name: 'ACTIVITY_LIST',
        component: () => import('@/views/Marketing/activity/list.vue'),
        meta: {
          title: '资料分享活动',
          module: 'homePage',
        },
      },
      {
        path: 'marketing/activity/detail',
        name: 'ACTIVITY_DETAIL',
        component: () => import('@/views/Marketing/activity/detail.vue'),
        meta: {
          title: '活动详情',
          module: 'homePage',
        },
      },
      {
        path: 'marketing/activity/plan',
        name: 'ACTIVITY_PLAN',
        component: () => import('@/views/Marketing/activity/plan.vue'),
        meta: {
          title: '活动策划',
          module: 'homePage',
        },
      },
      {
        path: '/404',
        name: 'NOTFOUND',
        component: ()=>import('@/views/NotFound'),
        meta: {
          title: '错误页',
        },
      },
    ],
    meta: {
      title: '首页',
    },
  },
];

const router = new Router({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to?.query?.info) {
    const { password, phoneNumber, xzptTenantId, relogin } = JSON.parse(decodeURIComponent(to.query.info));

    if (relogin) {
      localStorage.clear();
      sessionStorage.clear();

      next({
        name: 'LOGIN',
        query: {
          info: JSON.stringify({
            password,
            phoneNumber,
            xzptTenantId,
          }),
        },
      });
      return;
    }
  }

  // 公开页面（无需登录）直接放行
  if (to.meta && to.meta.public) {
    NProgress.start();
    document.title = to.meta.title || '';
    next();
    return;
  }

  let isLogin = !!localStorage.getItem('userInfo') && !!localStorage.getItem('token');
  if (to.name === 'LOGIN') {
    if (isLogin) {
      next({
        name: 'HOME',
      });
      return;
    } else {
      NProgress.start();
      next();
      return;
    }
  }
  if (!isLogin) {
    next({
      name: 'LOGIN',
      query: {
        redirect: to.fullPath,
      },
    });
    return;
  }

  if (!to.matched.length) {
    next({
      name: 'NOTFOUND',
    });
    return;
  }
  if (to.path === from.path) return;
  const { title, src } = to.params;
  if (to.path.indexOf('/iframe') >= 0 && src && src.indexOf('http') >= 0) {
    document.title = title || '小紫医疗';
  } else {
    document.title = to.meta.title || '小紫医疗';
  }
  NProgress.start();
  next();
  Common.savePageAccessRecord({ pageUrl: to.path, terminalType: 'PC' });
});
router.afterEach(() => {
  NProgress.done();
});

export default router;
